"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var promises_1 = require("./utils/promises");
var string_1 = require("./utils/string");
var IframeMessageProxy = (function () {
    function IframeMessageProxy() {
        this.eventPrefix = IframeMessageProxy.defaultBlipEventPrefix;
        this.receiveWindow = window;
        this.pendingRequestPromises = {};
        this.eventCaller = window.name;
        this.targetWindow = window.parent;
        this.handleOnReceiveMessage = this.onReceiveMessage.bind(this);
    }
    IframeMessageProxy.prototype.formatPayload = function (payload) {
        var trackingProperties = this.createTrackingProperties();
        return {
            message: __assign({}, payload, { action: "" + this.eventPrefix + payload.action, caller: this.eventCaller }),
            trackingProperties: trackingProperties
        };
    };
    IframeMessageProxy.prototype.createTrackingProperties = function () {
        return {
            id: string_1.randomStr()
        };
    };
    IframeMessageProxy.prototype.createPromiseCache = function (id, deferred) {
        this.pendingRequestPromises[id] = deferred;
    };
    IframeMessageProxy.prototype.shouldHandleMessage = function (message) {
        var _this = this;
        var passDefault = function (_a) {
            var data = _a.data;
            var evt = data;
            return evt.trackingProperties && evt.trackingProperties.id ? true : false;
        };
        var isHandleable = function (_a) {
            var data = _a.data;
            if (_this.validateMessage) {
                return passDefault({ data: data }) && _this.validateMessage(data);
            }
            return passDefault(message);
        };
        return isHandleable(message);
    };
    IframeMessageProxy.prototype.isError = function (message) {
        return message.error;
    };
    IframeMessageProxy.prototype.onReceiveMessage = function (evt) {
        if (!this.shouldHandleMessage(evt)) {
            return;
        }
        var message = evt.data;
        var deferred = this.pendingRequestPromises[message.trackingProperties.id];
        if (deferred) {
            if (this.isError(message)) {
                return deferred.reject(message.error);
            }
            return deferred.resolve(message);
        }
    };
    IframeMessageProxy.getInstance = function () {
        if (!IframeMessageProxy.instance) {
            IframeMessageProxy.instance = new IframeMessageProxy();
        }
        return IframeMessageProxy.instance;
    };
    IframeMessageProxy.prototype.config = function (options) {
        this.eventPrefix = options && options.prefix || IframeMessageProxy.defaultBlipEventPrefix;
        this.eventCaller = options && options.caller || window.name;
        this.receiveWindow = options && options.receiveWindow || window;
        this.targetWindow = options && options.targetWindow || window.parent;
        this.validateMessage = options && options.shouldHandleMessage;
        return this;
    };
    IframeMessageProxy.prototype.listen = function () {
        this.receiveWindow.addEventListener('message', this.handleOnReceiveMessage);
    };
    IframeMessageProxy.prototype.stopListen = function () {
        this.receiveWindow.removeEventListener('message', this.handleOnReceiveMessage);
    };
    IframeMessageProxy.prototype.sendMessage = function (payload) {
        var message = this.formatPayload(payload);
        var deferred = promises_1.createDeferred();
        this.createPromiseCache(message.trackingProperties.id, deferred);
        this.targetWindow.postMessage(message, '*');
        return deferred.promise;
    };
    IframeMessageProxy.defaultBlipEventPrefix = 'blipEvent:';
    return IframeMessageProxy;
}());
exports.IframeMessageProxy = IframeMessageProxy;
//# sourceMappingURL=data:application/json;base64,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